namespace GeniuzPOS.InitialData {
    export interface PsPosPrinterRow {
        Id?: number;
        PrinterId?: string;
        PrinterName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace PsPosPrinterRow {
        export const idProperty = 'PrinterId';
        export const nameProperty = 'PrinterId';
        export const localTextPrefix = 'InitialData.PsPosPrinter';
        export const lookupKey = 'InitialData.PsPosPrinter';

        export function getLookup(): Q.Lookup<PsPosPrinterRow> {
            return Q.getLookup<PsPosPrinterRow>('InitialData.PsPosPrinter');
        }
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:เครื่องPOS:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:เครื่องPOS:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:เครื่องPOS:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:เครื่องPOS:Modify';

        export declare const enum Fields {
            Id = "Id",
            PrinterId = "PrinterId",
            PrinterName = "PrinterName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
